import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';

import { Observable, of as observableOf } from 'rxjs';
import { TokenService } from 'viggo-sistemas-core-web';

@Injectable()
export class SelectiveStrategyService implements PreloadingStrategy {
  constructor(protected tokenService: TokenService) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    if (route.data && route.data.preload) {
      return load();
    }
    // TODO: PELO OQ EU ENTENDI O PRELOADING SO FUNCIONA A PARTIR DO ROUTERMODULE.ROOT OU SEJA OS COMPONENTES E MODULOS QUE POSSUEM ROTAS INTERNAS
    // NAO SERAO MAPEADOS POR ESSA CLASSE PARA PREENCHER O BREADCRUMB
    // else if (route.data && route.data.menuKey && this.tokenService.isMenuItemLs()) {
    //   route.data.breadcrumbMenu = Utils.getBreadcrumbMenu(
    //     route.data.menuKey,
    //     route.data.subMenuKey
    //   );
    //   return load();
    // }
    return observableOf(null);
  }
}
